import {doc} from './docs.js';
doc(
    "pack",
    {
        args: "args"
    },
    "Creats a list out of the inlets",
    undefined,
    {
        tags: "List",
        inlets: x => x
    }
);


export const pack = (object, ...args) => {
    return (msg) => {
        // get all the args
        let _args = args.map(x => x()).filter(x => x !== undefined);
        _args = _args.slice(0, _args.length - 1);
        return [[...msg, ..._args]];
    };
};

doc(
    "packFull",
    {
        args: "args"
    },
    "Creats a list out of the inlets (once all inlets are full)",
    undefined,
    {
        tags: "List",
        isHot: true,
        inlets: x => x
    }
);


export const packFull = (object, ...args) => {
    return (msg) => {
        // get all the args
        let _args = args.map(x => x()).filter(x => x !== undefined);
        _args = _args.slice(0, _args.length - 1);
        if (_args.some(x => !x)) {
            return;
        }
        return [[...msg, ..._args]];
    };
};


doc(
    "pak",
    {
        args: "args"
    },
    "Creates a list out of the inlets (all hot inlets)",
    undefined,
    {
        tags: "List",
        inlets: x => x,
        isHot: true
    }
);


export const pak = (object, ...args) => {
    return (msg) => {
        let _args = args.map(x => x())
            .filter(x => x !== undefined);
        _args = _args.slice(0, _args.length - 1);
        return [[...msg, ..._args]];
    };
};


doc(
    "unpack",
    {
        args: "args"
    },
    "Send a list out individual outlets",
    (n) => n,
    {
        tags: "List",
    }
);

export const unpack = (object, ...args) => {
    return (msg) => {
        return msg[0];
    };
};


doc(
    "replacepak",
    {
        list: "override list",
        args: "args"
    },
    "Pak but allows overriding the list",
    undefined,
    {
        tags: "List",
        inlets: x => x + 1,
        isHot: true
    }
);


export const replacepak = (object, ...args) => {
    object.lastMessageReceived = 0;
    let _msg;
    return ([msg]) => {
        if (msg !== _msg && Array.isArray(msg)) {
            object.args = [...msg];
            _msg = msg;
            return;
        }
        _msg = msg;
        let _args = args.map(x => x())
            .filter(x => x !== undefined);
        _args = _args.slice(0, _args.length);
        return [[..._args]];
    };
};


doc(
    "indexpack",
    {
        "index + value pair": "",
    },
    "Inserts into stored list at index",
    () => 1,
    {
        inlets: (x) => x + 1
    });
export const indexpack = (object, ...args) => {
    let storedList = undefined;
    return ([msg]) => {
        let len = args.filter(x => x() !== undefined && x() !== null).length
        if (msg.length === len) {
            storedList = [... msg];
            return [storedList];
        }
        let [index, val] = msg;
        if (!storedList) {
            storedList = new Array(len).fill(0);
            for (let i=0; i < storedList.length; i++) {
                storedList[i] = args[i]();
            }
        }
        storedList[index] = val;
        return [storedList];
    };
};

